/* eslint-disable react-refresh/only-export-components -- variant helper is a stable public styling API */
import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default:
          'border-[var(--color-border)] bg-[var(--color-surface-muted)] text-[var(--color-text-muted)]',
        primary:
          'border-[var(--color-border-strong)] bg-[var(--color-surface)] text-[var(--color-text)]',
        success:
          "border-[color-mix(in_srgb,var(--color-success)_24%,transparent)] bg-[color-mix(in_srgb,var(--color-success)_8%,var(--color-surface))] text-[var(--color-success)] before:h-1.5 before:w-1.5 before:rounded-full before:bg-current before:content-['']",
        warning:
          "border-[color-mix(in_srgb,var(--color-warning)_24%,transparent)] bg-[color-mix(in_srgb,var(--color-warning)_8%,var(--color-surface))] text-[var(--color-warning)] before:h-1.5 before:w-1.5 before:rounded-full before:bg-current before:content-['']",
        destructive:
          "border-[color-mix(in_srgb,var(--color-danger)_24%,transparent)] bg-[color-mix(in_srgb,var(--color-danger)_8%,var(--color-surface))] text-[var(--color-danger)] before:h-1.5 before:w-1.5 before:rounded-full before:bg-current before:content-['']",
        info:
          "border-[color-mix(in_srgb,var(--color-info)_24%,transparent)] bg-[color-mix(in_srgb,var(--color-info)_8%,var(--color-surface))] text-[var(--color-info)] before:h-1.5 before:w-1.5 before:rounded-full before:bg-current before:content-['']",
        neutral:
          'border-[var(--color-border)] bg-[var(--color-surface-muted)] text-[var(--color-text-muted)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants>

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { badgeVariants }
